import React from "react";
import { ProfileRow } from "../ProfileRow";
import { renderValue } from "../renderValueHelper";
import { useTranslation } from "@helpers/translate";
import changeIcon from "@assets/images/icons/change-icon.svg";
import saveIcon from "@assets/images/icons/save-icon.svg";
import cancelIcon from "@assets/images/icons/cancel-icon.svg";

import "./index.sass";

export const LastNameRow = ({
  lastName,
  editingField,
  editingValues,
  setEditingValues,
  lastNameInputRef,
  handleSaveField,
  setEditingField,
  savingField,
  fieldError,
  clearFieldError,
}) => {
  const { __ } = useTranslation();

  const normalizedLastName =
    typeof lastName === "string" ? lastName.trim() : "";

  const hasLastName = Boolean(normalizedLastName);

  const currentValue =
    typeof editingValues.last_name === "string"
      ? editingValues.last_name
      : "";


  const cancelEditing = () => {
    setEditingField(null);
    clearFieldError("last_name");

    setEditingValues((prev) => ({
      ...prev,
      last_name: normalizedLastName,
    }));
  };

  const handleSave = () => {
    if (hasLastName) return;

    handleSaveField("last_name", currentValue.trim());
  };

  const value =
    editingField === "last_name" && !hasLastName ? (
      <input
        ref={lastNameInputRef}
        type="text"
        className="profile-row__editable-input"
        value={currentValue}
        onChange={(event) => {
          clearFieldError("last_name");

          setEditingValues((prev) => ({
            ...prev,
            last_name: event.target.value,
          }));
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            handleSave();
          }

          if (event.key === "Escape") {
            cancelEditing();
          }
        }}
        placeholder={__("verification.step1.lastName") || "Last name"}
      />
    ) : (
      renderValue(normalizedLastName)
    );

  let actions = null;

  if (!hasLastName) {
    actions =
      editingField === "last_name" ? (
        <>
          <button
            type="button"
            onClick={handleSave}
            disabled={savingField === "last_name"}
            className="profile-action__save profile-action__button"
          >
            <img src={saveIcon} alt="save" />
          </button>

          <button
            type="button"
            onClick={cancelEditing}
            disabled={savingField === "last_name"}
            className="profile-action__cancel profile-action__button"
          >
            <img src={cancelIcon} alt="cancel" />
          </button>
        </>
      ) : (
        <button
          type="button"
          className="profile-action__button"
          onClick={() => {
            setEditingField("last_name");

            setEditingValues((prev) => ({
              ...prev,
              last_name: "",
            }));
          }}
        >
          <img src={changeIcon} alt="change" />
        </button>
      );
  }

  return (
    <ProfileRow
      label={__("verification.step1.lastName")}
      value={value}
      actions={actions}
      error={fieldError}
    />
  );
};